const mixin = {
  data: () => ({
    alertModalVisibility: false,
    modalAction: () => {}
  }),

  methods: {
    // alert modal methods
    closeAlertModal () {
      this.alertModalVisibility = false
    },

    openAlertModal (id, fn) {
      this.modalAction = this.makeModalAction(fn)(id)
      this.alertModalVisibility = true
    },

    makeModalAction (fn) {
      return (id) => () => { fn(id); this.closeAlertModal() }
    }
  }
}

export default mixin
